module.exports = __webpack_public_path__ + "assets/img/joinUs.49338b6e.jpg";